import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { polarisSettingsGlobalViewsRoute } from '@atlassian/jira-router-routes-polaris-routes/src/polarisSettingsGlobalViewsRoute.tsx';
import { polarisProductGlobalViewsSettingsPageEntry } from './ui/settings/global-views/polarisProductGlobalViewsSettingsPageEntry.tsx';

export const polarisSettingsGlobalViewsRouteEntry = createEntry(
	polarisSettingsGlobalViewsRoute,
	() => ({
		isStrictModeEnabled: false,
		group: 'global-settings',
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_PRODUCTS_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsProducts,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

		entryPoint() {
			return fg('polaris_global_views') ? polarisProductGlobalViewsSettingsPageEntry : undefined;
		},

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-polaris-entries/src/polarisSettingsGlobalViewsRouteEntry.tsx',
				whichExportToUse: 'polarisSettingsGlobalViewsRouteEntry',
			},

			enabled: true,
		},
	}),
);
